var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 18 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m8.5499 11.675c0.225 0.225 0.6 0.225 0.825 0l5.25-5.625c0.225-0.225 0.225-0.525 0-0.675-0.075-0.15-0.3-0.15-0.45-0.15h-2.625v-4.275c0-0.15-0.075-0.3-0.225-0.375-0.075-0.075-0.225-0.075-0.375-0.075h-3.975c-0.15 0-0.3 0-0.45 0.15-0.15 0.075-0.225 0.225-0.225 0.375v4.2h-2.55c-0.3 0-0.525 0.15-0.6 0.45 0 0.15 0 0.3 0.15 0.45l5.25 5.55zm7.05-0.975v3.45h-13.2v-3.45c0-0.45-0.3-0.75-0.75-0.75s-0.75 0.3-0.75 0.75v4.05c0 0.45 0.3 0.825 0.75 0.9h14.625c0.45-0.075 0.75-0.45 0.75-0.9v-4.05c0-0.45-0.3-0.75-0.75-0.75s-0.675 0.375-0.675 0.75c-0.075 0-0.075 0 0 0z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/downloadIcon.fa6db368ca42aaa1ba3b85af9bacb93d.svg";
export { ForwardRef as ReactComponent };